import React from "react";

import PageElementWrapper from "./PageElementWrapper";

export default function BrowserPageElementWrapper(props) {
  return <PageElementWrapper {...props} />;
}
